import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {GuardState} from "@/interfaces/state/guard";
import store from "@/store";
import {RouteConfig} from "vue-router";
import {asyncRoutes, constantRoutes} from "@/router";

export const filterAsyncRoutes = (routes: Array<RouteConfig>, roles: string[]) => {
    const resultRoutes = [] as any;
    routes.forEach((route: RouteConfig) => {
        const children = route.children?.filter((child: RouteConfig) => {
            return !child.meta?.role || roles.includes(child.meta?.role);
        });
        if (children?.length) {
            resultRoutes.push({ ...route, children: children } as any)
        }
    });
    return resultRoutes;
};

@Module({ dynamic: true, name: "guard", store })
class GuardModule extends VuexModule implements GuardState {
    dynamicRoutes: Array<RouteConfig> = [];
    routes: Array<RouteConfig> = [];

    @Mutation
    private SET_ROUTES(routes: Array<RouteConfig>) {
        this.routes = constantRoutes.concat(routes);
        this.dynamicRoutes = routes;
    }

    @Action
    public generateRoutes(roles: string[]) {
        // let accessedRoutes;
        // if (roles.includes("admin")) {
        //     accessedRoutes = asyncRoutes;
        // } else {
        //     accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
        // }
        this.SET_ROUTES(filterAsyncRoutes(asyncRoutes, roles));
    }
}

export const GuardStore = getModule(GuardModule);